import { type FC, type ReactNode } from 'react'
import { useIntl } from 'react-intl'

import { type GetCarriersV1 } from '@redteclab/api/clients/bully'

import { ShippingCarrierIds } from '../../../../shipping'

/**
 * belgium extra details for the shipping method
 */
export const ProductDeliveryInfoExtraDetailsForCarrier: FC<{
  carrier: GetCarriersV1
}> = ({ carrier }): ReactNode => {
  const intl = useIntl()

  switch (carrier.id) {
    case ShippingCarrierIds.beMondialRelayPickup: {
      return intl.formatMessage({
        id: 'buyBox.delivery.shippingMethod.mondialrelayPickup',
      })
    }
    case ShippingCarrierIds.bePostEvening: {
      return intl.formatMessage({
        id: 'buyBox.delivery.shippingMethod.bpostEvening',
      })
    }
    case ShippingCarrierIds.bePostHome: {
      return intl.formatMessage({
        id: 'buyBox.delivery.shippingMethod.bpostHome',
      })
    }
    case ShippingCarrierIds.bePostPoints: {
      return intl.formatMessage({
        id: 'buyBox.delivery.shippingMethod.bpostPoints',
      })
    }
    default: {
      return null
    }
  }
}
